import * as React from "react";

export default () => {
  return <div>Välj vilket lägenhet som gjort en betalning avseende den valda avgiftsgruppen</div>;
};
